import { AnyAction } from "redux";
import actions from "../../util/actions";
import { DiscipleshipClassReducerState } from "../../interfaces";

const initialState: DiscipleshipClassReducerState = {
  initial: false,
  loading: false,
  error: null,
  response: null,
  search: "",
  page: 0,
  pages: 0,
  data: [],
  total: 0,
  per_page: 20
};

const reducer = (state = initialState, action: AnyAction): DiscipleshipClassReducerState => {
  switch (action.type) {
    case actions.DISCIPLESHIP_CLASS_HTTP_LOADING:
      return { ...state, response: null, loading: true, error: null };
    case actions.DISCIPLESHIP_CLASS_HTTP_ERROR:
      if (action.payload.clear) {
        return { ...state, response: null, loading: false, error: null };
      }
      return { ...state, response: null, loading: false, error: { ...action.payload } };
    case actions.DISCIPLESHIP_CLASS_HTTP_COMPLETE:
      return { ...state, initial: true, response: action.payload.response, loading: false, error: null };
    case actions.SET_DISCIPLESHIP_CLASS_DETAILS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
